import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const navHistory: string[] = [];

export const useNavigationHistory = () => navHistory;

export const NavigationTracker = () => {
  const location = useLocation();

  const exclude = [
    '/codewindow',
    '/transaction/purchase/edit/',
    '/sales/return/code/window/',
    '/purchase/return/code/window/',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/transaction/sales/order/edit/',
    '/transaction/sales/order/create/',
    '/transaction/issue-refine/edit/',
    '/transaction/issue-party/edit/',
    '/transaction/receive/karigar/edit/',
    '/transaction/receive/karigar/create/',
    '/transaction/receive/party/create/',
    '/transaction/receive/party/edit/',
    '/transaction/receive/refine/edit/',
    '/transaction/receive/refine/create/',
    '/transaction/issue-karigar/edit/',
    '/transaction/issue/karigar/create/',
    '/transaction/issue/party/create/',
    '/transaction/stock/edit/',
    '/transaction/stock/create/',
    '/transaction/stock-adjustment/create/',
    '/transaction/stock-adjustment/edit/',
    '/opening/stock-adjustment/edit/',
    '/purchase-modal/create/',
    '/codewindow-modal/',
    '/transaction/purchase-modal/edit/',
    '/transaction/purchase-modal-sales/edit/',
    '/purchase-modal-sales/create/',
    '/codewindow-modal-sales/',
    '/codewindow-modal-sales-receive-party/',
    '/receive-from-party-modal-sales/create/',
  ];

  useEffect(() => {
    const currentPath = location?.pathname?.replace(/\/+$/, ''); // Remove trailing slashes
    const lastNavPath = navHistory?.[navHistory?.length - 1]?.replace(
      /\/+$/,
      '',
    ); // Remove trailing slashes from last history path

    if (
      !exclude?.some((path) => currentPath?.startsWith(path)) &&
      currentPath !== lastNavPath
    ) {
      navHistory?.push(location.pathname);
    }
  }, [location]);

  return null;
};
